import { Modal } from 'react-bootstrap';
import { usePopupContext } from './PopupContextProvider';
import { useCallback } from 'react';
import { Button, Image } from 'components/common';
import { useRouter } from 'next/router';
import useMobile from 'hooks/useMobile';
import menu from 'lib/home/data/raw.json';
import { routePaths } from 'appConfig';

const TimedPopup = () => {
  const { showTimedPopup, dismiss } = usePopupContext();
  const onClose = useCallback(() => dismiss(), [dismiss]);
  const router = useRouter();
  const isMobile = useMobile();

  const { product_sections } = menu;
  const customizableMeal = product_sections[0];

  const onCTAClick = useCallback(
    ({ isCustomiseMeal }: { isCustomiseMeal: boolean }) => {
      if (isCustomiseMeal) {
        router.push(
          `${routePaths.PRODUCTS}?category_ids=${customizableMeal.query?.category_ids?.[0]}`,
        );
        dismiss();
      } else {
        dismiss();
      }
    },
    [customizableMeal.query?.category_ids, dismiss, router],
  );

  return (
    <Modal
      backdrop="static"
      show={showTimedPopup}
      centered
      onHide={onClose}
      size="lg"
      className="tw-p-0"
    >
      <Modal.Body className="tw-p-0">
        <div className="md:tw-flex tw-relative tw-w-full">
          <div
            className={
              isMobile
                ? 'tw-hidden'
                : 'tw-w-full md:tw-w-[40%] md:tw-flex-shrink-0 tw-h-[32rem] md:tw-h-auto tw-relative'
            }
          >
            <Image
              src="/assets/images/popups/empty-cart.png"
              alt="Empty Cart"
              width={1500}
              height={2121}
              priority
              layout={isMobile ? 'fill' : 'responsive'}
              className="tw-w-full tw-h-full tw-object-cover tw-object-[50%_10%] md:tw-object-center"
            />
          </div>
          <div className="tw-w-full md:tw-flex-1 tw-px-8 tw-py-8 md:tw-py-28 tw-flex tw-flex-col tw-justify-center tw-items-center tw-relative">
            <div className="tw-flex tw-flex-col tw-space-y-8">
              <div className="tw-flex tw-flex-col tw-space-y-4">
                <h1 className="tw-font-therebrat tw-text-[5.5rem] md:tw-text-[6.75rem] tw-font-medium tw-tracking-wide tw-mb-0 tw-text-center tw-leading-none">
                  Not Sure
                </h1>
                <h2 className="tw-text-center tw-text-4xl tw-font-extrabold tw-mb-0 tw-leading-none">
                  How Yummy Bros Works?
                </h2>
              </div>
              <p className="tw-text-center tw-mb-0 tw-leading-tight tw-text-[#333] tw-text-2xl">
                It's simpler than you think!
              </p>
              <ol className="tw-text-center tw-leading-tight tw-text-[#333] tw-text-2xl">
                <li>1. Add meals to your cart</li>
                <li>2. Select a delivery date at checkout</li>
                <li>3. Make payment and receive your order!</li>
              </ol>
              <p className="tw-text-center tw-mb-0 tw-leading-tight tw-text-[#333] tw-text-2xl">
                You'll love our Customisable Meals.
                <br />
                Choose your protein, carbs, veggies, & portion sizes!
              </p>
              <div className="tw-flex tw-justify-center tw-gap-4">
                <Button
                  className="tw-uppercase tw-text-[1.1rem] md:tw-text-[1.25rem] tw-flex-1 tw-w-full tw-whitespace-nowrap"
                  onClick={() =>
                    onCTAClick({ isCustomiseMeal: true })
                  }
                >
                  <>Customise My Meal</>
                </Button>
                <Button
                  className="tw-flex-1 tw-uppercase tw-text-[1.1rem] md:tw-text-[1.25rem] tw-min-w-0 tw-w-full tw-text-[#666] tw-whitespace-nowrap"
                  color="dark"
                  variant="outlined"
                  onClick={() =>
                    onCTAClick({ isCustomiseMeal: false })
                  }
                >
                  <>Continue Exploring</>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <button
          title="Close (Esc)"
          type="button"
          className={
            isMobile
              ? 'tw-hidden'
              : 'mfp-close tw-top-2 tw-right-2 tw-text-[1.5rem]'
          }
          onClick={onClose}
        >
          <span>×</span>
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default TimedPopup;
